import { ROUTES } from '../../utils/constants';

import {

  getMalayAiTutorActivity,

  isMalayLegacyReadingActivityKey,

  type MalayAiTutorActivity,

  type MalayAiTutorActivityKey,

} from './malayAiTutorActivities';

import type { ResolvedLearnerCurriculum } from '../curriculum/learnerCurriculumTypes';

import {

  isEffectiveMalayLearner,

  isExplicitTamilLearner,

  shouldDeferMixedTenantLearnerPocNav,

  shouldWaitForCurriculumRouting,

} from '../curriculum/learnerCurriculumOverride';



export const MALAY_AI_TUTOR_ACTIVITY_QUERY_PARAM = 'activity';



export type AiTutorLiveView =

  | { kind: 'loading' }

  | { kind: 'curriculum_unresolved'; message: string }

  | { kind: 'tamil_live' }

  | { kind: 'malay_selection' }

  | { kind: 'malay_live'; activity: MalayAiTutorActivity }

  | { kind: 'malay_reading_redirect' }

  | { kind: 'malay_invalid_redirect' };



export function buildMalayAiTutorLiveUrl(
  activityKey: MalayAiTutorActivityKey,
  options?: { topicId?: string; mode?: 'assessment' | 'teaching' },
): string {
  const params = new URLSearchParams({ [MALAY_AI_TUTOR_ACTIVITY_QUERY_PARAM]: activityKey });
  const topicId = options?.topicId?.trim();
  if (topicId) params.set('topic_id', topicId);
  if (options?.mode === 'assessment') params.set('mode', 'assessment');
  return `${ROUTES.STUDENT_TAMIL_TUTOR}?${params.toString()}`;
}



export function parseMalayAiTutorActivityParam(

  activityParam: string | null | undefined,

): MalayAiTutorActivity | null {

  return getMalayAiTutorActivity(activityParam?.trim() ?? null);

}



function resolveMalayAiTutorLiveView(activityParam: string | null): AiTutorLiveView {

  const trimmed = activityParam?.trim() ?? '';

  if (!trimmed) {

    return { kind: 'malay_selection' };

  }



  if (isMalayLegacyReadingActivityKey(trimmed)) {

    return { kind: 'malay_reading_redirect' };

  }



  const activity = getMalayAiTutorActivity(trimmed);

  if (!activity) {

    return { kind: 'malay_invalid_redirect' };

  }



  return { kind: 'malay_live', activity };

}



/**

 * Pure route resolver for /student/ai-tutor-live.

 *

 * Precedence:

 * 1. Explicit Tamil enrollment → Tamil live path

 * 2. Otherwise original pre-Tamil tenant routing (legacy Malay vs Tamil)

 */

export function resolveAiTutorLiveView(input: {

  labelsLoading: boolean;

  legacyTenantIsMalay: boolean;

  curriculumLoading: boolean;

  curriculum: ResolvedLearnerCurriculum | null;

  activityParam: string | null;

}): AiTutorLiveView {

  if (input.labelsLoading) {

    return { kind: 'loading' };

  }



  if (isExplicitTamilLearner(input.curriculum)) {

    return { kind: 'tamil_live' };

  }



  if (

    shouldWaitForCurriculumRouting({

      legacyTenantIsMalay: input.legacyTenantIsMalay,

      curriculumLoading: input.curriculumLoading,

      curriculum: input.curriculum,

    })

  ) {

    return { kind: 'loading' };

  }



  if (

    shouldDeferMixedTenantLearnerPocNav({

      legacyTenantIsMalay: input.legacyTenantIsMalay,

      curriculum: input.curriculum,

      curriculumLoading: input.curriculumLoading,

    })

  ) {

    return {

      kind: 'curriculum_unresolved',

      message: 'Learner curriculum is not resolved for this school.',

    };

  }



  const isMalay = isEffectiveMalayLearner({

    curriculum: input.curriculum,

    legacyTenantIsMalay: input.legacyTenantIsMalay,

  });



  if (!isMalay) {

    return { kind: 'tamil_live' };

  }



  return resolveMalayAiTutorLiveView(input.activityParam);

}

